<div class="withdraw-assets">
  <div>
    <p class="ds-heading-2">{{ 'ACCOUNT.withdrawalV2.assetBar.label' | translate }}</p>
    <p class="ds-heading-2">{{ withdrawalAllocation.totalAmount.toFixed(0) | thousand: currency }}</p>
  </div>

  <ng-container *ngIf="accountInvested">
    <app-ds-allocation-bar
      [allocationItems]="[withdrawalAllocation.initial, withdrawalAllocation.portfolio, withdrawalAllocation.cash]"
      [customColors]="['var(--color-core-brand-2-2)', 'var(--color-core-brand-6-2)', 'var(--color-core-neutral-3)']"
    ></app-ds-allocation-bar>

    <div>
      <app-ds-legend color="custom" customColor="var(--color-core-brand-2-2)">
        <span class="ds-ui-3 ds-color-core-neutral-7">{{ 'ACCOUNT.withdrawalV2.assetBar.legends.required' | translate }}</span>
      </app-ds-legend>
      <p class="ds-caption-2 ds-color-neutral-7">{{ withdrawalAllocation.initial.value.toFixed(0) | thousand: currency }}</p>
    </div>

    <div>
      <app-ds-legend color="custom" customColor="var(--color-core-brand-6-2)">
        <span class="ds-ui-3 ds-color-core-neutral-7">{{ 'ACCOUNT.withdrawalV2.assetBar.legends.safe' | translate }}</span>
      </app-ds-legend>
      <p class="ds-caption-2 ds-color-neutral-7">{{ withdrawalAllocation.portfolio.value.toFixed(0) | thousand: currency }}</p>
    </div>

    <div *ngIf="withdrawalAllocation.cash.value">
      <app-ds-legend color="custom" customColor="var(--color-core-neutral-3)">
        <span class="ds-ui-3 ds-color-core-neutral-7">{{ 'ACCOUNT.withdrawalV2.assetBar.legends.cash' | translate }}</span>
      </app-ds-legend>
      <p class="ds-caption-2 ds-color-neutral-7">{{ withdrawalAllocation.cash.value.toFixed(0) | thousand: currency }}</p>
    </div>
  </ng-container>
</div>

<h2 class="ds-heading-2">{{ 'ACCOUNT.withdrawalV2.amount.heading' | translate }}</h2>

<div class="withdraw-options" [formGroup]="parent">
  <ng-container *ngFor="let option of selectOptions">
    <app-ds-radio-option [value]="option?.value" [selected]="typeControl.value" (clicked)="onChangeType($event)" variant="box">
      <ng-container ds-radio-title>{{ option?.title | translate }}</ng-container>
      <ng-container ds-radio-desc>{{ option?.desc | translate }}</ng-container>
    </app-ds-radio-option>

    <ng-container *ngIf="option.value === withdrawType.PARTIAL && typeControl.value === withdrawType.PARTIAL">
      <div class="ds-form-row" [class.has-error]="amountControl.dirty && amountControl.invalid">
        <label class="ds-label">{{ 'ACCOUNT.withdrawalV2.amount.input.label' | translate: { currency: currency } }}</label>
        <input
          class="ds-input"
          [placeholder]="'ACCOUNT.withdrawalV2.amount.input.placeholder' | translate"
          type="number"
          [formControlName]="'amount'"
          (keyup.enter)="onContinue()"
        />

        <div *ngIf="amountControl.dirty && amountControl.invalid" class="ds-input-error">
          <ng-container *ngIf="amountControl.hasError('exceeds')">
            {{ 'ACCOUNT.withdrawalV2.amount.input.limitError' | translate }}
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="amountControl.dirty && showMinWarning(amountControl.value) && accountInvested">
        <app-ds-callout
          id="callout"
          variant="warning"
          [title]="'ACCOUNT.withdrawalV2.amount.warning.title' | translate"
          [description]="'ACCOUNT.withdrawalV2.amount.warning.description' | translate: { amount: minAmountText }"
        ></app-ds-callout>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<app-ds-button [disabled]="parent.invalid" [width]="isMobileApp ? 'full' : 'auto'" (clicked)="onContinue()">
  {{ 'ACCOUNT.withdrawalV2.buttons.next' | translate }}
</app-ds-button>
